<template>
  <div class="poly_mian" @click="show_poly = false">
    <div class="poly_list" :style="{ top: top + 'px', left: left + 'px' }" v-if="show_poly">
      <div class="poly_list_btn" v-for="(item, index) in poly_list" :key="index" @click.stop="setTextPoly(item)">
        {{ item }}
      </div>
      <span @click="removePolyphone()" class="poly_remove">删除</span>
    </div>
    <div class="poly_con">
      <div class="poly_contop">
        <p>
          <span>点击需要纠正的多音字，选择正确的发音</span>
          <span class="poly_contop_prompt">(拼音 声调)声调5声代表轻声,v代表ü</span>
        </p>
        <img src="../assets/images/img2/offlogin.png" @click="offPolyphone" />
      </div>
      <div class="poly_text" id="poly_text">
        <p class="text_con" v-for="(item, index) in text_list" :key="index" :class="item.multi ? 'ispoly' : ''" @click="setPolyphone(item, index, $event)">
          <span v-html="item.word"></span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: false,
    },
  },
  data() {
    return {
      text_list: [], //多音字识别列表
      poly_list: [], //发音列表
      top: 0, //发音列表top距离
      left: 0, //发音列表left距离
      show_poly: false, //发音列表显示状态
      text_index: 0, //当前操作的字的索引
      index_list: [],
    };
  },
  mounted() {
    this.recognitPolyphone();
  },
  methods: {
    // 存储识别前的拼音状态
    savePinYinState() {
      // 恢复多音字样式
      let text = this.text
      var reg = new RegExp(
        /<span class="polyphone" contenteditable="false">.*?<\/span>/,
        "g"
      );
      var index_list;
      var i = 0;
      while ((index_list = reg.exec(text)) != null) {
        let index = index_list.index;
        index -= i;
        this.index_list.push({ con: index_list, index: index });
        i += index_list[0].length;
      }
    },
    // 并返回纠正后的文本
    offPolyphone() {
      this.$store.commit("setShowPloy", false);
      let html = document.getElementById("poly_text").innerHTML;
      let text = html
        .replace(/<p class="text_con ispoly">/g, "")
        .replace(/<p class="text_con">/g, "")
        .replace(/<\/p>/g, "")
        .replace(/<span>/g, "")
        .replace(/<\/span>/g, "")
        .replace(
          /(<span class="polyphone" contenteditable="false">[a-z]+\d+)/g,
          "$1</span>"
        );
      this.$emit("setPoly", text);
    },
    // 删除设置的发音
    removePolyphone() {
      // 如果已经设置发音先删除之前的发音
      if (this.text_list[this.text_index].word.indexOf("polyphone") != -1) {
        let text = this.text_list[this.text_index].word.replace(
          /<span class="polyphone" contenteditable="false">.*?<\/span>/g,
          ""
        );
        this.text_list[this.text_index].word = text;
      }
    },
    // 设置字符发音
    setTextPoly(item) {
      // // 如果已经设置发音先删除之前的发音
      this.removePolyphone();
      this.$set(
        this.text_list[this.text_index],
        "word",
        this.text_list[this.text_index].word +
        `<span class="polyphone" contenteditable="false">${item}</span>`
      );
      this.show_poly = false;
    },
    // 查询多音字
    recognitPolyphone() {
      this.savePinYinState();
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.ismultipinyin;
      let json = {
        text: this.text.replace(
          /<span class="polyphone" contenteditable="false">.*?<\/span>/g,
          ""
        ),
      };
      this.$request.postHttp(json, url, (response) => {
        console.log(response)
        self.text_list = response.model;
        // 恢复原来的拼音状态
        self.index_list.forEach((item) => {
          self.text_list[item.index - 1].word =
            self.text_list[item.index - 1].word + item.con;
        });
      })
    },
    // 查询多音列表
    setPolyphone(item, index, e) {
      if (!item.multi) return;
      let self = this;
      this.text_index = index;
      // 这个接口不用加解密
      let url =
        self.$store.state.app_api + self.$store.state.app_url.getmultipinyin;
      let json = {
        text: item.word,
      };
      this.$request.postHttp(json, url, (response) => {
        self.poly_list = response.model;
        this.left = e.target.getBoundingClientRect().left;
        this.top = parseInt(e.target.getBoundingClientRect().top) + 30;
        self.show_poly = true;
      })
    },
  },
};
</script>
<style>
.poly_contop_prompt {
  color: #fe8a06;
  font-size: 14px !important;
}
.poly_remove {
  cursor: pointer;
}
.polyphone {
  height: 24px;
  background: rgba(254, 138, 6, 0.1);
  border-radius: 6px;
  color: #fe8a06;
  padding: 0 14px;
  margin: 0 4px;
  display: inline-block;
  line-height: 24px;
}
.text_con {
  display: inline-block;
}
.poly_list_btn {
  height: 28px;
  padding: 0 20px;
  background: #fe8a06;
  border-radius: 4px;
  color: #fff;
  line-height: 28px;
  margin-right: 10px;
  cursor: pointer;
}
.poly_list {
  position: absolute;
  height: 40px;
  padding: 6px 10px;
  background-color: #fff;
  border: 1px solid #eeeeee;
  box-shadow: 0px 10px 14px -10px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  display: flex;
  align-items: center;
}
.ispoly {
  color: #fe8a06;
}
.poly_text span {
  cursor: pointer;
}
.poly_text::-webkit-scrollbar {
  width: 10px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
.poly_text::-webkit-scrollbar-track {
  border-radius: 5px; /*滚动条的背景区域的圆角*/
}
/*定义滑块 内阴影+圆角*/
.poly_text::-webkit-scrollbar-thumb {
  border-radius: 5px; /*滚动条的圆角*/
  background-color: rgba(153, 153, 153, 0.4);
}
.poly_text {
  width: 100%;
  height: 478px;
  padding: 20px;
  background-color: #f8f8f8;
  overflow-y: scroll;
  font-size: 16px;
  line-height: 30px;
}
.poly_contop span {
  font-size: 18px;
}
.poly_contop img {
  width: 14px;
  height: 14px;
}
.poly_contop {
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.poly_con {
  width: 952px;
  height: 540px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.poly_mian {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/polyphone.vue